export default __webpack_public_path__ + "static/media/informatique.1f1f1ff4.jpg";